// Copyright (c) 2019 Sagacity Solutions Inc. All right reserved.
'use strict';

import { helpers } from "vuelidate/lib/validators";

export const phonenumber = helpers.regex('phonenumber', /^[+]?[0-9]?[-\s.]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/);
